


















import { Component, Vue, Prop } from "vue-property-decorator";

@Component
class IconDefi extends Vue {
  @Prop() type;

  @Prop({ type: Boolean, default: false }) pure;

  get colors() {
    return ["currentColor", "currentColor"];
    // if (this.$attrs.pure) {
    //   return ["currentColor", "currentColor"];
    // }
    // return this.type === "disabled"
    //   ? ["#CCCCCC", "#CCCCCC"]
    //   : ["#0F9AFF", "#67BFFF"];
  }
}
export default IconDefi;
